export type UserDisplayIdentity = {
  name?: string | null;
  email?: string | null;
  nameSetByUser?: boolean;
};

/** Hide system-derived email prefixes while preserving names the user saved. */
export function userDisplayName(
  user: UserDisplayIdentity | null | undefined,
  fallback: string
): string {
  const name = user?.name?.trim();
  const localPart = user?.email?.split('@', 1)[0]?.trim();
  if (
    name &&
    (user?.nameSetByUser === true ||
      !localPart ||
      name.toLowerCase() !== localPart.toLowerCase())
  ) {
    return name;
  }
  return fallback;
}
